import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { DROP_DOWN_ACTIONS } from '../main-list-carrier.component';
import { Carrier } from '@app/services/carriers/carrier.model';

@Component({
  selector: 'app-list-drop-down',
  templateUrl: './list-drop-down.component.html',
  styleUrls: ['./list-drop-down.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ListDropDownComponent implements OnInit {
  DROP_DOWN_ACTIONS = DROP_DOWN_ACTIONS;
  @Input() imgSrc: string;
  @Input() carrier: Carrier;
  @Input() isShowEditOption: boolean = true;
  @Input() isShowVerificationOption: boolean = false;
  @Output() onActionEmit = new EventEmitter<{
    event: DROP_DOWN_ACTIONS;
    currentCarrier: Carrier;
  }>();
  showOption: boolean = false;

  constructor(private eRef: ElementRef) {}
  ngOnInit(): void {}

  @HostListener('document:click', ['$event'])
  clickOutSide(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.toggleOptionOff();
    }
  }

  async toggleOption() {
    this.showOption = !this.showOption;
  }

  closeDropDown(): void {
    this.showOption = false;
  }

  toggleOptionOff() {
    this.showOption = false;
  }

  onAction(event: DROP_DOWN_ACTIONS): void {
    const currentCarrier = this.carrier;
    this.onActionEmit.emit({ event, currentCarrier });
  }
}
